// extracted by mini-css-extract-plugin
export default {"addCard":"FqZKMqSH","addIcon":"vEWPrY1E"};